import { useIntl } from 'react-intl';

import type { SelectOption } from '@/components/Select';
import { useListingState } from '@/hooks/useListingState';
import { ENVIRONMENT_NAME } from '@/lib/const';
import { commonMessages } from '@/messages/common';
import { useRegionProvider } from '@/providers/RegionProvider';
import type { ListingType } from '@/states/listingState';

const getIndexName = (listingType: ListingType | '', channelSlug: string) => {
  if (listingType === 'STORE') {
    return `${ENVIRONMENT_NAME}.${listingType}`;
  }

  return `${ENVIRONMENT_NAME}.PRODUCT.${channelSlug}`;
};

export const useListingSortBy = () => {
  const { formatMessage } = useIntl();
  const { country } = useRegionProvider();
  const { listingType } = useListingState();

  const indexName = getIndexName(listingType, country.channelSlug);

  const options: SelectOption[] = [
    {
      label: formatMessage(commonMessages.suggested),
      value: indexName,
    },
    {
      label: formatMessage(commonMessages.newIn),
      value: `${indexName}.newest`,
    },
    {
      label: formatMessage(commonMessages.priceAsc),
      value: `${indexName}.price_asc`,
    },
    {
      label: formatMessage(commonMessages.priceDesc),
      value: `${indexName}.price_desc`,
    },
  ];

  return options;
};
